import { TeamRole } from '@foxtrotplatform/platform-micro-site-core';
import {
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHeader,
  TableRow,
} from '@windmill/react-ui';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  removeTeamMember,
  setTeamMembers,
} from '../../common/reducers/teamMemberSlice';
import { TeamMemberComponent, TeamMemberEditComponent } from './TeamMember';

export const TeamMemberTable: React.FunctionComponent = (): JSX.Element => {
  const dispatch = useDispatch();
  const teamMembers: TeamMember[] = useSelector<AppState, TeamMember[]>(
    ({ teamMembers }) => {
      return teamMembers;
    }
  );
  const [editingMemberId, setEditingMemberId] = useState<string>('');
  const [pageTable, setPageTable] = useState(1);
  const [dataTable, setDataTable] = useState<TeamMember[]>([]);
  const resultsPerPage = 5;

  useEffect(() => {
    setDataTable(
      teamMembers.slice(
        (pageTable - 1) * resultsPerPage,
        pageTable * resultsPerPage
      )
    );
  }, [pageTable, teamMembers]);

  const onPageChange = (pageNumber: number) => {
    setPageTable(pageNumber);
  };

  const updateTable = (id: string, role: TeamRole) => {
    dispatch(
      setTeamMembers(
        [...teamMembers].map((member) => {
          if (member.id === id) {
            member = { ...member, role: role };
          }
          return member;
        })
      )
    );
  };

  const removeFromTable = (id: string) => {
    dispatch(removeTeamMember(id));
  };

  const mapMembers = () => {
    if (!dataTable) {
      return;
    }

    return (
      <TableBody>
        {dataTable.map((member, i) => {
          if (member.id === editingMemberId) {
            return (
              <TeamMemberEditComponent
                key={`${member.email}_${i}`}
                member={member}
                removeFromTable={removeFromTable}
                toggleEdit={setEditingMemberId}
                updateTable={updateTable}
              />
            );
          } else {
            return (
              <TeamMemberComponent
                key={`${member.email}_${i}`}
                member={member}
                toggleEdit={setEditingMemberId}
              />
            );
          }
        })}
      </TableBody>
    );
  };

  return (
    <TableContainer>
      <Table>
        <TableHeader>
          <TableRow>
            <TableCell>Email</TableCell>
            <TableCell>Team Role</TableCell>
            <TableCell>Action</TableCell>
          </TableRow>
        </TableHeader>
        {mapMembers()}
      </Table>
      <TableFooter>
        <Pagination
          label="Table navigation"
          onChange={onPageChange}
          resultsPerPage={resultsPerPage}
          totalResults={teamMembers?.length}
        />
      </TableFooter>
    </TableContainer>
  );
};
